/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormTextarea
} from "shards-react";
import { accessCheck } from "../../utils/tools";
import moment from 'moment-timezone'
import { WEB_PAYMENT_URL } from "../../environmentVariables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faFileInvoice, faFileInvoiceDollar, faSearch, faTimes, faArrowDown, faArrowUp, faExclamationTriangle, faCheckCircle, faTimesCircle, faEye, faPercent, faExternalLinkAlt, faFile, faEnvelope, faPhone, faBrain, faColumns, faList, faCheck, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import PageTitle from "../../components/common/PageTitle";
import Pagination from "../../components/common/Pagination";
import ActivityIndicator from "../../components/common/ActivityIndicator";
import DownloadButton from "../../components/common/DownloadButton";
import EnhancedDateRangePicker from "../../components/common/EnhancedDateRangePicker";
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfDay, endOfDay, sub } from "date-fns";
import generatePDF, { Resolution, Margin } from 'react-to-pdf';

import "react-datepicker/dist/react-datepicker.css";
import DisputeQuickView from "./DisputeQuickView";
import DisputeAnalysisContainer from "../../components/DisputeAnalysis/DisputeAnalysisContainer";
import RowActions from '../../components/common/RowActions';

// We're now using EnhancedDateRangePicker, which includes its own styles
/* const datePickerStyles = `
  .react-datepicker {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    border-radius: 6px;
    border: 1px solid #eaedf3;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }
  
  .react-datepicker__header {
    background-color: #fff;
    border-bottom: 1px solid #eaedf3;
    padding-top: 10px;
  }
  
  .react-datepicker__current-month {
    color: #495057;
    font-weight: 600;
    margin-bottom: 8px;
  }
  
  .react-datepicker__day-name {
    color: #818ea3;
    font-size: 12px;
    margin: 3px;
  }
  
  .react-datepicker__day {
    color: #495057;
    margin: 3px;
    border-radius: 4px;
  }
  
  .react-datepicker__day:hover {
    background-color: rgba(33, 170, 115, 0.05);
  }
  
  .react-datepicker__day--selected,
  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background-color: rgba(33, 170, 115, 0.8);
    color: white;
  }
  
  .react-datepicker__day--keyboard-selected {
    background-color: rgba(33, 170, 115, 0.5);
    color: white;
  }
  
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background-color: rgba(33, 170, 115, 0.5);
  }
  
  .react-datepicker__day--in-range {
    background-color: rgba(33, 170, 115, 0.8);
    color: white;
  }
  
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selecting-range-end {
    background-color: #21AA73;
    color: white;
  }
  
  .react-datepicker__navigation {
    top: 10px;
  }
  
  .react-datepicker__navigation-icon::before {
    border-color: #21AA73;
  }
  
  .react-datepicker__navigation:hover *::before {
    border-color: #21AA73;
  }
`; */

const Citations = (props) => {

  const [citations, setCitations] = useState([]);
  const [startDate, setStartDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedStartDate = localStorage.getItem('enforcePlus_startDate');
    return savedStartDate ? new Date(savedStartDate) : startOfDay(new Date());
  });
  const [endDate, setEndDate] = useState(() => {
    // Check if there's a saved date range in localStorage
    const savedEndDate = localStorage.getItem('enforcePlus_endDate');
    return savedEndDate ? new Date(savedEndDate) : endOfDay(new Date());
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [status, setStatus] = useState(props.statusFilter || 'all');
  const [client, setClient] = useState(props.clientFilter || 'all');
  const [location, setLocation] = useState(props.locationFilter || 'all');
  const [violationType, setViolationType] = useState('all');
  const [sortBy, setSortBy] = useState('dateDesc')
  const [search, setSearch] = useState(props.searchFilter || '');
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(() => {
    // Try to load saved page size from localStorage
    const savedPageSize = localStorage.getItem('citations_page_size');
    return savedPageSize ? parseInt(savedPageSize, 10) : 25;
  });
  const [endablePdfMode, setEndablePdfMode] = useState(false);
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [showDisputeModal, setShowDisputeModal] = useState(false);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [selectedForAnalysis, setSelectedForAnalysis] = useState(null);
  // Column visibility state
  const [visibleColumns, setVisibleColumns] = useState(() => {
    // Try to load saved preferences from localStorage
    const savedPreferences = localStorage.getItem('citations_visible_columns');
    if (savedPreferences) {
      try {
        return JSON.parse(savedPreferences);
      } catch (e) {
        console.error("Error parsing saved column preferences", e);
      }
    }
    
    // Default columns if no saved preferences
    return {
      license_plate: true,
      plate_state: false,
      id: true,
      date_time: true,
      location: true,
      issued_by: true,
      previous_offenses: false,
      total: true,
      status: true
    };
  });
  const [showColumnSelector, setShowColumnSelector] = useState(false);
  // Add this state to track open dropdowns
  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [activeCalendar, setActiveCalendar] = useState(null);
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  const [selectedCitationForPayment, setSelectedCitationForPayment] = useState(null);

  // Add ref for the column selector button
  const columnSelectorRef = useRef(null);

  // Save column preferences whenever they change
  useEffect(() => {
    localStorage.setItem('citations_visible_columns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const allColumns = [
    { id: 'license_plate', label: 'License plate' },
    { id: 'plate_state', label: 'Plate state' },
    { id: 'id', label: '#ID' },
    { id: 'date_time', label: 'Date/Time' },
    { id: 'location', label: 'Location' },
    { id: 'issued_by', label: 'Issued by' },
    { id: 'previous_offenses', label: 'Citations' },
    { id: 'total', label: 'Total' },
    { id: 'status', label: 'Status' }
  ];

  const csvHeader = allColumns
    .filter(column => visibleColumns[column.id])
    .map(column => column.label);

  const getPreviousCitationsCount = (citation) => {
    if (!props.citations || !citation) return 0;
    
    // Get all citations for the same license plate that were created before this one
    const previousCitations = props.citations.filter(c => 
      c.license_plate === citation.license_plate && 
      new Date(c.created_at) < new Date(citation.created_at)
    );
    
    return previousCitations.length;
  };

  // Extract unique violations from citations
  const getUniqueViolations = () => {
    const typeMap = new Map();
    filterCitations(true).forEach(citation => {
      let type =
        citation.violation_type ||
        citation.violation_description ||
        (citation.violations && citation.violations[0] && citation.violations[0].name) ||
        'Unknown';
      if (type && type.trim() !== '') {
        const key = type.trim().toLowerCase();
        if (!typeMap.has(key)) {
          typeMap.set(key, type.trim());
        }
      }
    });
    return Array.from(typeMap.values()).sort();
  };

  const generateFileData = () => {
    let citationsTemp = [...filterCitations()]
    let csvDataArray = citationsTemp.map(citation => {
      const rowData = [];
      
      if (visibleColumns.license_plate) rowData.push(citation.license_plate);
      if (visibleColumns.plate_state) rowData.push(citation.license_plate_state || '');
      if (visibleColumns.id) rowData.push(citation.violation_number);
      if (visibleColumns.date_time) rowData.push(moment(citation.created_at).format('MM/DD/Y h:mm a'));
      if (visibleColumns.location) rowData.push(citation.location_name);
      if (visibleColumns.issued_by) rowData.push(props.users.find(user => user.id === citation.user)?.name);
      if (visibleColumns.previous_offenses) rowData.push(getPreviousCitationsCount(citation));
      if (visibleColumns.total) rowData.push(citation.payment_on ? 
        parseFloat(parseFloat(citation.payment.amount) - (citation?.payment?.card_last_four ? parseFloat(citation.service_fee) : 0)).toFixed(2) : 
        parseFloat(citation.total).toFixed(2));
      if (visibleColumns.status) rowData.push(getCsvStatus(citation));
      
      return rowData;
    });
    
    return [csvHeader, ...csvDataArray]
  }

  const generateList = () => {
    if (endablePdfMode) {
      return filterCitations()
    } else {
      return filterCitations().slice((page - 1) * pageSize, ((page - 1) * pageSize) + pageSize);
    }
  }

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    // Save to localStorage for persistence
    localStorage.setItem('citations_page_size', newSize.toString());
    // Reset to first page when changing page size
    setPage(1);
  }

  const getTargetElement = () => document.getElementById('content-id');

  const generateFilePdf = () => {
    const options = {
      method: 'save',
      resolution: Resolution.NORMAL,
      page: {
        margin: Margin.SMALL,
        format: 'A4',
        orientation: 'portrait',
      },
      canvas: {
        mimeType: 'image/jpeg',
        qualityRatio: 1
      },
      overrides: {
        pdf: {
          compress: true
        },
        canvas: {
          useCORS: true
        }
      },
      filename: 'enforceplus_citations.pdf'
    };

    setEndablePdfMode(true);
    setTimeout(() => {
      generatePDF(getTargetElement, options);
      setTimeout(() => {
        setEndablePdfMode(false);
      }, 1000);
    }, 1000);
  }

  useEffect(() => {
    props.getAllCitations(startDate, endDate, { clientId: client, locationId: location })
    // Save date range to Redux
    props.setDateRangeFilter({ startDate, endDate })
    document.title = 'Citations: EnforcePlus admin';
    !accessCheck(props.user, 'citations') && (window.location.href = '/')
    props.clearCitation()
  }, [])

  useEffect(() => {
    props.getAllCitations(startDate, endDate, { clientId: client, locationId: location })
  }, [startDate, endDate, client, location])

  useEffect(() => {
    setCitations(props.citations)
  }, [props.citations])

  useEffect(() => {
    if (props.citations?.length > 0) {
      setCitations(props.citations);
    }
  }, [status, client]);

  // useEffect(() => {
  //   if (props.addedLocation) {
  //     setAddedLocation(true);
  //     setTimeout(() => {
  //       setAddedLocation(false)
  //       props.clearAddedLocation()
  //     }, 10000);
  //   }
  //   if (props.updatedLocation) {
  //     setUpdatedLocation(true);
  //     setTimeout(() => {
  //       setUpdatedLocation(false)
  //       props.clearAddedLocation()
  //     }, 10000);
  //   }
  // }, [props.addedLocation, props.updatedLocation])

  
  
  const filterCitations = (skipViolationType = false) => {
    let sortedCitations = [...citations];
    if (search !== '') {
      sortedCitations = sortedCitations.filter(citation => (
        citation.violation_number.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || citation.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || citation.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        || (props.users?.find(user => user.id === citation.user)?.name || '').toLowerCase().indexOf(search.toLowerCase()) !== -1
      ))
    }
    if (status !== 'all') {
      props.setStatusFilter(status)
      if (status === 'closed') {
        sortedCitations = sortedCitations.filter(citation => citation.status === 'closed' || citation.payment_on)
      } else if (status === 'void') {
        sortedCitations = sortedCitations.filter(citation => citation.status === 'void')
      } else if (status === 'unpaid') {
        sortedCitations = sortedCitations.filter(citation => !citation.payment_on && citation.status !== 'closed' && citation.status !== 'void')
      } else {
        sortedCitations = sortedCitations.filter(citation => citation.dispute?.status === 'open' && !citation.payment_on)
      }
    }
    if (status === 'all') {
      props.setStatusFilter(status)
    }
    if (client !== 'all') {
      props.setClientFilter(client)
      sortedCitations = sortedCitations.filter(citation => citation.client === client)
    }
    if (client === 'all') {
      props.setClientFilter(client)
    }
    if (location !== 'all') {
      props.setLocationFilter(location)
      sortedCitations = sortedCitations.filter(citation => citation.location === location)
    }
    if (location === 'all') {
      props.setLocationFilter(location)
    }
    if (!skipViolationType && violationType !== 'all') {
      sortedCitations = sortedCitations.filter(citation => {
        // Check root-level fields
        const rootType =
          citation.violation_type ||
          citation.violation_description ||
          undefined;
        // Check all names in violations array
        const violationNames = (citation.violations || []).map(v => v && v.name && v.name.trim()).filter(Boolean);
        // Aggregate all possible names
        const allNames = [
          ...(rootType ? [rootType.trim()] : []),
          ...violationNames
        ].map(name => name.toLowerCase());
        return allNames.includes(violationType.trim().toLowerCase());
      });
    }
    if (sortBy === 'dateDesc') {
      sortedCitations = sortedCitations.sort((a, b) => a.created_at && b.created_at && moment(a.created_at).isBefore(moment(b.created_at)) ? 1 : -1);
    }
    if (sortBy === 'dateAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.created_at && b.created_at && moment(a.created_at).isBefore(moment(b.created_at)) ? -1 : 1);
    }
    if (sortBy === 'licenseAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.license_plate.localeCompare(b.license_plate));
    }
    if (sortBy === 'licenseDesc') {
      sortedCitations = sortedCitations.sort((a, b) => b.license_plate.localeCompare(a.license_plate));
    }
    if (sortBy === 'idAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.violation_number.localeCompare(b.violation_number));
    }
    if (sortBy === 'idDesc') {
      sortedCitations = sortedCitations.sort((a, b) => b.violation_number.localeCompare(a.violation_number));
    }
    if (sortBy === 'locationAsc') {
      sortedCitations = sortedCitations.sort((a, b) => a.location_name.localeCompare(b.location_name));
    }
    if (sortBy === 'locationDesc') {
      sortedCitations = sortedCitations.sort((a, b) => b.location_name.localeCompare(a.location_name));
    }
    if (sortBy === 'userAsc') {
      sortedCitations = sortedCitations.sort((a, b) => props.users.find(user => user.id === a.user)?.name?.localeCompare(props.users.find(user => user.id === b.user)?.name));
    }
    if (sortBy === 'userDesc') {
      sortedCitations = sortedCitations.sort((a, b) => props.users.find(user => user.id === b.user)?.name?.localeCompare(props.users.find(user => user.id === a.user)?.name));
    }
    if (sortBy === 'totalAsc') {
      sortedCitations = sortedCitations.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount) : parseFloat(b.violations_total)) ? 1 : -1);
    }
    if (sortBy === 'totalDesc') {
      sortedCitations = sortedCitations.sort((a, b) => (a.payment_on ? parseFloat(a.payment.amount) : parseFloat(a.violations_total)) > (b.payment_on ? parseFloat(b.payment.amount) : parseFloat(b.violations_total)) ? -1 : 1);
    }
    if (sortBy === 'statusAsc') {
      sortedCitations = sortedCitations.sort((a, b) => (a?.payment_on ? 'closed' : a?.dispute?.status === 'open' ? 'disputed' : 'unpaid').localeCompare(b?.payment_on ? 'closed' : b?.dispute?.status === 'open' ? 'disputed' : 'unpaid'));
    }
    if (sortBy === 'statusDesc') {
      sortedCitations = sortedCitations.sort((a, b) => (b?.payment_on ? 'closed' : b?.dispute?.status === 'open' ? 'disputed' : 'unpaid').localeCompare(a?.payment_on ? 'closed' : a?.dispute?.status === 'open' ? 'disputed' : 'unpaid'));
    }
    if (sortBy === 'offensesAsc') {
      sortedCitations = sortedCitations.sort((a, b) => getPreviousCitationsCount(a) - getPreviousCitationsCount(b));
    }
    if (sortBy === 'offensesDesc') {
      sortedCitations = sortedCitations.sort((a, b) => getPreviousCitationsCount(b) - getPreviousCitationsCount(a));
    }
    return sortedCitations.slice();
  }

  const citationAction = (citation, action) => {
    if (action === 'view_receipt') {
      window.open(citation.payment.receipt_url)
    }
    if (action === 'view_citation') {
      window.location.href = './citation/' + citation.violation_number
    }
    if (action === 'mark_paid') {
      setSelectedCitationForPayment(citation);
      setShowPaymentMethodModal(true);
    }
    if (action === 'view_dispute') {
      setSelectedDispute(citation);
      setShowDisputeModal(true);
    }
    if (action === 'ai_analyze_dispute') {
      setSelectedForAnalysis(citation);
      setShowAnalysisModal(true);
    }
    if (action === 'take_payment') {
      window.open(WEB_PAYMENT_URL + '/violations/' + citation.vehicle)
    }
  }

  const handleAcceptDispute = (citation, note) => {
    props.acceptDispute(citation, note);
    
    // Update local state immediately
    let tempCitations = [...citations];
    let index = tempCitations.findIndex(cit => cit.id === citation.id);
    if (index !== -1) {
      tempCitations[index] = {
        ...tempCitations[index],
        dispute: {...tempCitations[index].dispute, status: 'accepted'},
        status: 'closed',
        total: "0.00"
      };
      setCitations(tempCitations);
    }
    
    // Close the modal
    setShowDisputeModal(false);
  }

  const handleRejectDispute = (citation, note) => {
    props.rejectDispute(citation, note);
    
    // Update local state immediately
    let tempCitations = [...citations];
    let index = tempCitations.findIndex(cit => cit.id === citation.id);
    if (index !== -1) {
      tempCitations[index] = {
        ...tempCitations[index],
        dispute: {...tempCitations[index].dispute, status: 'rejected'}
      };
      setCitations(tempCitations);
    }
    
    // Close the modal
    setShowDisputeModal(false);
  }

  const handleAdjustDispute = (citation, amount, note) => {
    props.adjustDispute(citation, amount, note);
    
    // Update local state immediately
    let tempCitations = [...citations];
    let index = tempCitations.findIndex(cit => cit.id === citation.id);
    if (index !== -1) {
      tempCitations[index] = {
        ...tempCitations[index],
        dispute: {...tempCitations[index].dispute, status: 'adjusted'},
        total: amount
      };
      setCitations(tempCitations);
    }
    
    // Close the modal
    setShowDisputeModal(false);
  }

  const handleViewFullCitation = (citation) => {
    window.location.href = './citation/' + citation.violation_number;
  }

  const handlePaymentMethodSelection = (paymentMethod) => {
    if (!selectedCitationForPayment) return;
    
    let tempCitations = [...citations]
    let index = tempCitations.findIndex(cit => cit.id === selectedCitationForPayment.id)
    tempCitations[index].status = "closed"
    tempCitations[index].payment_on = moment.utc().toISOString()
    tempCitations[index].payment = {
      type: paymentMethod.toLowerCase(),
      amount: parseFloat(selectedCitationForPayment.violations_total).toFixed(2)
    }
    props.markAsPaid(selectedCitationForPayment, paymentMethod.toLowerCase())
    setCitations(tempCitations)
    
    setShowPaymentMethodModal(false);
    setSelectedCitationForPayment(null);
  }

  const renderStatus = (citation) => {
    if (citation?.status === 'void') {
      return (
        <span className="badge" style={{
          backgroundColor: 'rgba(108, 117, 125, 0.15)',
          color: '#6c757d',
          fontSize: '11px',
          padding: '5px 10px',
          borderRadius: '12px'
        }}>
          VOID
        </span>
      );
    } else if (citation?.payment_on) {
      return (
        <span className="badge" style={{
          backgroundColor: 'rgba(0, 123, 255, 0.15)',
          color: '#007bff',
          fontSize: '11px',
          padding: '5px 10px',
          borderRadius: '12px'
        }}>
          CLOSED
        </span>
      );
    } else if (citation?.dispute?.status === 'open') {
      return (
        <span 
          className="badge" 
          style={{
            backgroundColor: 'rgba(249, 138, 1, 0.15)',
            color: '#F98A01',
            fontSize: '11px',
            padding: '5px 10px',
            borderRadius: '12px',
            cursor: 'pointer',
            position: 'relative',
            transition: 'all 0.2s ease'
          }}
          onClick={() => citationAction(citation, 'view_dispute')}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(249, 138, 1, 0.25)';
            const tooltip = e.target.querySelector('.status-tooltip');
            if (tooltip) tooltip.style.opacity = '1';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(249, 138, 1, 0.15)';
            const tooltip = e.target.querySelector('.status-tooltip');
            if (tooltip) tooltip.style.opacity = '0';
          }}
        >
          DISPUTED
          <div className="status-tooltip" style={{
            position: 'absolute',
            bottom: 'calc(100% + 10px)',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#333',
            color: '#fff',
            padding: '5px 10px',
            borderRadius: '4px',
            fontSize: '11px',
            whiteSpace: 'nowrap',
            opacity: '0',
            transition: 'opacity 0.2s ease',
            pointerEvents: 'none',
            zIndex: '10'
          }}>
            Click to view dispute details
            <div style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '0',
              height: '0',
              borderLeft: '5px solid transparent',
              borderRight: '5px solid transparent',
              borderTop: '5px solid #333'
            }}></div>
          </div>
        </span>
      );
    } else if (citation?.status === 'closed') {
      return (
        <span className="badge" style={{
          backgroundColor: 'rgba(0, 123, 255, 0.15)',
          color: '#007bff',
          fontSize: '11px',
          padding: '5px 10px',
          borderRadius: '12px'
        }}>
          CLOSED
        </span>
      );
    } else {
      return (
        <span className="badge" style={{
          backgroundColor: 'rgba(230, 73, 46, 0.15)',
          color: '#E6492E',
          fontSize: '11px',
          padding: '5px 10px',
          borderRadius: '12px'
        }}>
          UNPAID
        </span>
      );
    }
  }

  const getCsvStatus = (citation) => {
    if (citation?.status === 'void') {
      return ('Void')
    } else if (citation?.payment_on) {
      return ('Closed')
    } else if (citation?.dispute?.status === 'open') {
      return ('Disputed')
    } else if (citation?.status === 'closed') {
      return ('Closed')
    } else {
      return ('Unpaid')
    }
  }

  // Add this function to toggle dropdown state

  // Memoize date calculations
  const datePresets = React.useMemo(() => ({
    today: {
      start: startOfDay(new Date()),
      end: endOfDay(new Date())
    },
    yesterday: {
      start: startOfDay(sub(new Date(), { days: 1 })),
      end: endOfDay(sub(new Date(), { days: 1 }))
    },
    lastWeek: {
      start: startOfDay(sub(new Date(), { days: 6 })),
      end: endOfDay(new Date())
    },
    lastMonth: {
      start: startOfDay(sub(new Date(), { days: 29 })),
      end: endOfDay(new Date())
    }
  }), []);

  // Memoize date handlers
  const handleDateChange = React.useCallback((type, date) => {
    if (!date) return;
    
    if (type === 'start') {
      setStartDate(date);
      localStorage.setItem('enforcePlus_startDate', date.toISOString());
    } else {
      setEndDate(date);
      localStorage.setItem('enforcePlus_endDate', date.toISOString());
    }
  }, []);

  // Memoize preset handler
  const handlePresetClick = React.useCallback((preset) => {
    const { start, end } = datePresets[preset];
    setStartDate(start);
    setEndDate(end);
    localStorage.setItem('enforcePlus_startDate', start.toISOString());
    localStorage.setItem('enforcePlus_endDate', end.toISOString());
    setShowDatePickerModal(false);
  }, [datePresets]);

  // Memoize formatted dates with a more compact format
  const formattedDateRange = React.useMemo(() => {
    return `${moment(startDate).format('D MMM')} - ${moment(endDate).format('D MMM YY')}`;
  }, [startDate, endDate]);

  // Add click outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      if (columnSelectorRef.current && !columnSelectorRef.current.contains(event.target)) {
        setShowColumnSelector(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Container fluid className="main-content-container px-4">
      <style>
        {`
          .citation-row:hover {
            background-color: rgba(33, 170, 115, 0.03);
            cursor: pointer;
          }
          
          .table th {
            border-top: none;
          }
          
          .table td {
            vertical-align: middle;
          }
          
          .actions-dropdown-right .dropdown-menu {
            right: 0 !important;
            left: auto !important;
            transform: none !important;
          }
          
          .filter-active .select__control {
            border-color: #21AA73 !important;
            border-width: 2px !important;
            box-shadow: 0 0 5px rgba(33, 170, 115, 0.2) !important;
            background-color: rgba(33, 170, 115, 0.05) !important;
          }
        `}
      </style>
      
      <Row noGutters className="page-header py-4">
        <PageTitle title="Citations" className="text-sm-left mb-3" />
      </Row>

      <Card small className="mb-4" style={{
        borderRadius: '6px', 
        boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
        border: '1px solid #eaedf3'
      }}>
        <CardHeader className="border-bottom">
          <Row>
            <Col xs={12} className="d-flex align-items-center">
              <h6 className="m-0 mr-3 font-weight-bold d-flex align-items-center">
                <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73', opacity: 0.8}} />
                ({filterCitations().length})
              </h6>

              {props.user.type === 'super' && (
                <Select
                  id="feClients"
                  className={client !== 'all' ? "basic-select filter-active mr-2" : "basic-select mr-2"}
                  classNamePrefix="select"
                  placeholder="All clients"
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: '180px'
                    }),
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                      boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                      '&:hover': {
                        borderColor: 'rgba(33, 170, 115, 0.4)'
                      }
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected 
                        ? 'rgba(33, 170, 115, 0.1)' 
                        : state.isFocused 
                          ? 'rgba(33, 170, 115, 0.05)' 
                          : null,
                      color: state.isSelected ? '#21AA73' : base.color,
                      padding: '10px 12px',
                      borderBottom: '1px solid #eaedf3',
                      '&:last-child': {
                        borderBottom: 'none'
                      }
                    })
                  }}
                  value={client === 'all' 
                    ? { value: 'all', label: 'All clients' } 
                    : props.clients && props.clients.find(c => c.id === client) 
                      ? { value: client, label: props.clients.find(c => c.id === client).name }
                      : { value: 'all', label: 'All clients' }
                  }
                  onChange={(selectedOption) => setClient(selectedOption.value)}
                  options={[
                    { value: 'all', label: 'All clients' },
                    ...props.clients && props.clients.sort((a, b) => a.name.localeCompare(b.name)).map(c => ({
                      value: c.id,
                      label: c.name
                    })) || []
                  ]}
                />
              )}

              <Button 
                theme="white"
                onClick={() => setShowDatePickerModal(true)}
                className="d-flex align-items-center mr-2"
                style={{
                  borderColor: '#dfe3e9',
                  padding: '0.4375rem 0.75rem',
                  height: '36px',
                  width: '180px',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                  justifyContent: 'space-between',
                  whiteSpace: 'nowrap'
                }}
              >
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                  <span style={{ color: '#495057', fontSize: '13px' }}>{formattedDateRange}</span>
                </div>
              </Button>

              {!(props.user?.embed && props.user?.location) && (
                <Select
                  id="feLocations"
                  className={location !== 'all' ? "basic-select filter-active mr-2" : "basic-select mr-2"}
                  classNamePrefix="select"
                  placeholder="All locations"
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: '180px'
                    }),
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                      boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                      '&:hover': {
                        borderColor: 'rgba(33, 170, 115, 0.4)'
                      }
                    })
                  }}
                  value={location === 'all'
                    ? { value: 'all', label: 'All locations' }
                    : props.locations && props.locations.find(loc => loc.id === location)
                      ? { value: location, label: props.locations.find(loc => loc.id === location).name }
                      : { value: 'all', label: 'All locations' }
                  }
                  onChange={(selectedOption) => setLocation(selectedOption.value)}
                  options={[
                    { value: 'all', label: 'All locations' },
                    ...props.locations && props.locations.sort((a, b) => a.name.localeCompare(b.name)).map(loc => ({
                      value: loc.id,
                      label: loc.name
                    })) || []
                  ]}
                />
              )}

              <Select
                id="feStatus"
                className={status !== 'all' ? "basic-select filter-active mr-2" : "basic-select mr-2"}
                classNamePrefix="select"
                placeholder="All statuses"
                styles={{
                  container: (base) => ({
                    ...base,
                    width: '180px'
                  }),
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                    boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                    '&:hover': {
                      borderColor: 'rgba(33, 170, 115, 0.4)'
                    }
                  })
                }}
                value={
                  status === 'all' ? { value: 'all', label: 'All statuses' } : 
                  status === 'unpaid' ? { value: 'unpaid', label: 'Unpaid' } : 
                  status === 'disputed' ? { value: 'disputed', label: 'Disputed' } : 
                  status === 'closed' ? { value: 'closed', label: 'Closed' } : 
                  { value: 'void', label: 'Void' }
                }
                onChange={(selectedOption) => setStatus(selectedOption.value)}
                options={[
                  { value: 'all', label: 'All statuses' },
                  { value: 'unpaid', label: 'Unpaid' },
                  { value: 'disputed', label: 'Disputed' },
                  { value: 'closed', label: 'Closed' },
                  { value: 'void', label: 'Void' }
                ]}
              />

              <Select
                id="feViolations"
                className={violationType !== 'all' ? "basic-select filter-active mr-2" : "basic-select mr-2"}
                classNamePrefix="select"
                placeholder="All violations"
                styles={{
                  container: (base) => ({
                    ...base,
                    width: '180px'
                  }),
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? 'rgba(33, 170, 115, 0.4)' : undefined,
                    boxShadow: state.isFocused ? '0 0 0 1px rgba(33, 170, 115, 0.4)' : undefined,
                    '&:hover': {
                      borderColor: 'rgba(33, 170, 115, 0.4)'
                    }
                  })
                }}
                value={
                  violationType === 'all' ? { value: 'all', label: 'All violations' } : 
                  { value: violationType, label: violationType }
                }
                onChange={(selectedOption) => setViolationType(selectedOption.value)}
                options={[
                  { value: 'all', label: 'All violations' },
                  ...getUniqueViolations().map(type => ({
                    value: type,
                    label: type
                  }))
                ]}
              />

              <div className="search-container flex-grow-1 mr-3" style={{ position: 'relative', maxWidth: '100%' }}>
                <input
                  type="text"
                  placeholder="Search citations..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px 32px 8px 36px',
                    fontSize: '14px',
                    border: '1px solid #dfe3e9',
                    borderRadius: '4px',
                    backgroundColor: '#f8f9fa',
                    transition: 'all 0.2s ease',
                    outline: 'none',
                    height: '36px'
                  }}
                  onFocus={(e) => {
                    e.target.style.backgroundColor = '#fff';
                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(33, 170, 115, 0.1)';
                    e.target.style.borderColor = 'rgba(33, 170, 115, 0.4)';
                  }}
                  onBlur={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = '#dfe3e9';
                  }}
                />
                <FontAwesomeIcon 
                  icon={faSearch} 
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#818ea3'
                  }}
                />
                {search && (
                  <FontAwesomeIcon 
                    icon={faTimes}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#818ea3',
                      cursor: 'pointer'
                    }}
                    onClick={() => setSearch('')}
                  />
                )}
              </div>

              <div style={{ display: 'flex', gap: '8px' }}>
                <div style={{ width: '180px' }}>
                  <DownloadButton
                    filename={"enforceplus_citations"}
                    fileData={generateFileData()}
                    showPdfLoading={endablePdfMode}
                    createPdf={() => generateFilePdf()}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="px-4">
          {props.gettingAllCitations ? (
            <div className="loading-container text-center py-5">
              <ActivityIndicator size="large" />
              <p className="mt-3 text-muted">Loading citations data...</p>
            </div>
          ) : filterCitations().length === 0 ? (
            <div className="text-center py-5">
              <FontAwesomeIcon icon={faFileInvoice} size="2x" style={{color: '#21AA73', marginBottom: '10px', opacity: 0.8}} />
              <h6>No citations found</h6>
              <p style={{fontSize: '12px', color: '#9EA0A5'}}>Try changing your filters or date range.</p>
            </div>
          ) : (
            <>
              <div className="table-responsive" id="content-id">
                <table className="table mb-0">
                  <thead className="bg-light">
                    <tr>
                      {visibleColumns.license_plate && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'licenseAsc' ? 'licenseAsc' : 'licenseDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            License plate
                            {sortBy === 'licenseAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'licenseDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.plate_state && (
                        <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          Plate state
                        </th>
                      )}
                      {visibleColumns.id && (
                        <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'idAsc' ? 'idAsc' : 'idDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            #ID
                            {sortBy === 'idAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'idDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.date_time && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'dateDesc' ? 'dateDesc' : 'dateAsc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Date/Time
                            {sortBy === 'dateDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'dateAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.location && (
                        <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'locationAsc' ? 'locationAsc' : 'locationDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Location
                            {sortBy === 'locationAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'locationDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.issued_by && (
                        <th scope="col" className="border-0 d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'userAsc' ? 'userAsc' : 'userDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Issued by
                            {sortBy === 'userAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'userDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.previous_offenses && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'offensesAsc' ? 'offensesAsc' : 'offensesDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Citations
                            {sortBy === 'offensesAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'offensesDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.total && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'totalAsc' ? 'totalAsc' : 'totalDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Total
                            {sortBy === 'totalAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'totalDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      {visibleColumns.status && (
                        <th scope="col" className="border-0" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div onClick={() => setSortBy(sortBy !== 'statusAsc' ? 'statusAsc' : 'statusDesc')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                            Status
                            {sortBy === 'statusAsc' && <FontAwesomeIcon icon={faArrowUp} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                            {sortBy === 'statusDesc' && <FontAwesomeIcon icon={faArrowDown} className="ml-1" size="xs" style={{color: '#21AA73'}} />}
                          </div>
                        </th>
                      )}
                      { !endablePdfMode && (
                        <th scope="col" className="border-0 text-right d-none d-md-table-cell" style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>
                          <div ref={columnSelectorRef} style={{ position: 'relative', display: 'inline-block', marginRight: '12px' }}>
                            <Button
                              theme="white"
                              size="sm"
                              style={{
                                borderColor: '#dfe3e9',
                                color: '#818ea3',
                                height: '24px',
                                padding: '0 8px',
                                fontSize: '11px',
                                minWidth: '80px'
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowColumnSelector(!showColumnSelector);
                              }}
                            >
                              <FontAwesomeIcon icon={faColumns} className="mr-1" size="sm" />
                              Columns
                            </Button>

                            {showColumnSelector && (
                              <div 
                                style={{
                                  position: 'absolute',
                                  top: 'calc(100% + 4px)',
                                  right: '0',
                                  width: '220px',
                                  backgroundColor: '#fff',
                                  boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                                  borderRadius: '6px',
                                  border: '1px solid #eaedf3',
                                  zIndex: 1050,
                                  padding: '12px'
                                }}
                              >
                                <div style={{ 
                                  borderBottom: '1px solid #eaedf3', 
                                  paddingBottom: '8px', 
                                  marginBottom: '8px',
                                  fontSize: '13px',
                                  fontWeight: '600',
                                  color: '#3D5170'
                                }}>
                                  Show/Hide Columns
                                </div>
                                {allColumns.map(column => (
                                  <div 
                                    key={column.id}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      padding: '6px 0',
                                      cursor: 'pointer',
                                      transition: 'background-color 0.2s ease',
                                      margin: '0 -12px',
                                      padding: '6px 12px'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = 'rgba(33, 170, 115, 0.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setVisibleColumns(prev => ({
                                        ...prev,
                                        [column.id]: !prev[column.id]
                                      }));
                                    }}
                                  >
                                    <div style={{
                                      width: '16px',
                                      height: '16px',
                                      border: '2px solid',
                                      borderColor: visibleColumns[column.id] ? '#21AA73' : '#dfe3e9',
                                      borderRadius: '3px',
                                      marginRight: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: visibleColumns[column.id] ? '#21AA73' : 'transparent',
                                      transition: 'all 0.2s ease'
                                    }}>
                                      {visibleColumns[column.id] && (
                                        <FontAwesomeIcon 
                                          icon={faCheck} 
                                          style={{ 
                                            color: '#fff',
                                            fontSize: '10px'
                                          }} 
                                        />
                                      )}
                                    </div>
                                    <span style={{
                                      fontSize: '13px',
                                      color: '#495057'
                                    }}>
                                      {column.label}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </th>
                      )}
                      { !endablePdfMode &&
                        <th scope="col" className="border-0"></th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {props.citations && filterCitations().length > 0 && generateList().map(citation => {
                      return (
                        <React.Fragment key={citation.id}>
                          <tr style={{transition: 'background-color 0.2s ease'}} className="citation-row">
                            {visibleColumns.license_plate && (
                              <td style={{padding: '12px'}}>
                                <span style={{fontWeight: '500'}}>{citation.license_plate}</span>
                              </td>
                            )}
                            {visibleColumns.plate_state && (
                              <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                <span style={{color: '#495057'}}>{citation.license_plate_state}</span>
                              </td>
                            )}
                            {visibleColumns.id && (
                              <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                <span style={{color: '#495057'}}>{citation.violation_number}</span>
                              </td>
                            )}
                            {visibleColumns.date_time && (
                              <td style={{padding: '12px'}}>
                                <span style={{color: '#495057'}}>{moment(citation.created_at).format('MM/DD/Y')}
                                  <div style={{fontSize: '12px', color: '#818ea3'}}>{moment(citation.created_at).format('h:mm a')}</div>
                                </span>
                              </td>
                            )}
                            {visibleColumns.location && (
                              <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                <span style={{color: '#495057'}}>{citation.location_name}</span>
                              </td>
                            )}
                            {visibleColumns.issued_by && (
                              <td style={{padding: '12px'}} className={"d-none d-md-table-cell"}>
                                <span style={{color: '#495057'}}>{props.users.find(user => user.id === citation.user)?.name}</span>
                              </td>
                            )}
                            {visibleColumns.previous_offenses && (
                              <td style={{padding: '12px'}} className={"text-center"}>
                                <span style={{
                                  fontWeight: '500', 
                                  color: getPreviousCitationsCount(citation) > 0 ? '#E6492E' : '#495057',
                                  backgroundColor: getPreviousCitationsCount(citation) > 0 ? 'rgba(230, 73, 46, 0.08)' : 'transparent',
                                  padding: getPreviousCitationsCount(citation) > 0 ? '3px 8px' : '0',
                                  borderRadius: '12px'
                                }}>
                                  {getPreviousCitationsCount(citation)}
                                </span>
                              </td>
                            )}
                            {visibleColumns.total && (
                              <td style={{padding: '12px'}}>
                                <span style={{fontWeight: '500'}}>${citation.payment_on ? parseFloat(parseFloat(citation.payment.amount) - ((citation?.payment?.card_last_four) ? parseFloat(citation.service_fee) : 0)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : parseFloat(citation.total).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                              </td>
                            )}
                            {visibleColumns.status && (
                              <td style={{padding: '12px'}}>
                                {renderStatus(citation)}
                              </td>
                            )}
                            { !endablePdfMode &&
                              <td className={"text-right d-none d-md-table-cell"}>
                                <RowActions>
                                    {citation.payment_on && citation.payment?.receipt_url && (
                                      <RowActions.Item onClick={(e) => {
                                        e.stopPropagation();
                                        citationAction(citation, 'view_receipt');
                                      }}>
                                        <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73'}} />
                                        View receipt
                                      </RowActions.Item>
                                    )}
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      citationAction(citation, 'view_citation');
                                    }}>
                                      <FontAwesomeIcon icon={faFile} className="mr-2" style={{color: '#818ea3'}} />
                                      View citation
                                    </RowActions.Item>
                                    {citation.dispute?.status === 'open' && (
                                      <>
                                        <RowActions.Item onClick={(e) => {
                                          e.stopPropagation();
                                          citationAction(citation, 'view_dispute');
                                        }}>
                                          <FontAwesomeIcon icon={faEye} className="mr-2" style={{color: '#818ea3'}} />
                                          Quick View Dispute
                                        </RowActions.Item>
                                      </>
                                    )}
                                    {(!citation.payment_on && citation.status !== 'closed' && citation.status !== 'void') && (
                                      <>
                                        <RowActions.Divider />
                                        <RowActions.Item onClick={(e) => {
                                          e.stopPropagation();
                                          citationAction(citation, 'mark_paid');
                                        }}>
                                          <FontAwesomeIcon icon={faCheckCircle} className="mr-2" style={{color: '#21AA73'}} />
                                          Mark as paid
                                        </RowActions.Item>
                                        <RowActions.Item onClick={(e) => {
                                          e.stopPropagation();
                                          citationAction(citation, 'take_payment');
                                        }}>
                                          <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73'}} />
                                          Take payment
                                        </RowActions.Item>
                                      </>
                                    )}
                                  </RowActions>
                              </td>
                            }
                          </tr>
                            {!endablePdfMode && (
                          <tr className="d-md-none d-xs-table-row">
                            <td className="border-top-0"></td>
                            <td colSpan={
                              // Calculate colspan based on visible columns
                              Object.values(visibleColumns).filter(Boolean).length - 1 // Subtract 1 for the first column
                            } className={"text-right border-top-0"}>
                                <RowActions>
                                    {citation.payment_on && citation.payment?.receipt_url && (
                                      <RowActions.Item onClick={(e) => {
                                        e.stopPropagation();
                                        citationAction(citation, 'view_receipt');
                                      }}>
                                        <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73'}} />
                                        View receipt
                                      </RowActions.Item>
                                    )}
                                    <RowActions.Item onClick={(e) => {
                                      e.stopPropagation();
                                      citationAction(citation, 'view_citation');
                                    }}>
                                      <FontAwesomeIcon icon={faFile} className="mr-2" style={{color: '#818ea3'}} />
                                      View citation
                                    </RowActions.Item>
                                    {citation.dispute?.status === 'open' && (
                                      <>
                                        <RowActions.Item onClick={(e) => {
                                          e.stopPropagation();
                                          citationAction(citation, 'view_dispute');
                                        }}>
                                          <FontAwesomeIcon icon={faEye} className="mr-2" style={{color: '#818ea3'}} />
                                          Quick View Dispute
                                        </RowActions.Item>
                                      </>
                                    )}
                                    {(!citation.payment_on && citation.status !== 'closed' && citation.status !== 'void') && (
                                      <>
                                        <RowActions.Divider />
                                        <RowActions.Item onClick={(e) => {
                                          e.stopPropagation();
                                          citationAction(citation, 'mark_paid');
                                        }}>
                                          <FontAwesomeIcon icon={faCheckCircle} className="mr-2" style={{color: '#21AA73'}} />
                                          Mark as paid
                                        </RowActions.Item>
                                        <RowActions.Item onClick={(e) => {
                                          e.stopPropagation();
                                          citationAction(citation, 'take_payment');
                                        }}>
                                          <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{color: '#21AA73'}} />
                                          Take payment
                                        </RowActions.Item>
                                      </>
                                    )}
                                  </RowActions>
                            </td>
                          </tr>
                            )}
                          </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <Pagination
                data={filterCitations()}
                pageSize={pageSize}
                page={page}
                onPageChange={(newPage) => setPage(newPage)}      
                onPageSizeChange={handlePageSizeChange}
              />
            </>
          )}
        </CardBody>
      </Card>

      {/* Date Picker Modal */}
      <Modal
        open={showDatePickerModal}
        toggle={() => setShowDatePickerModal(!showDatePickerModal)}
        size="lg"
        className="date-picker-modal"
      >
        <ModalHeader toggle={() => setShowDatePickerModal(false)}>
          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
          Select Date Range
        </ModalHeader>
        <ModalBody className="p-4">
          <Row>
            <Col md="8">
              <Card>
                <CardBody className="p-4">
                  <div className="d-flex" style={{ gap: '24px' }}>
                    <div className="flex-grow-1">
                      <Button 
                        block
                        theme="white"
                        style={{
                          borderColor: '#e1e5eb',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          position: 'relative',
                          height: '38px'
                        }}
                        onClick={() => setActiveCalendar(activeCalendar === 'start' ? null : 'start')}
                      >
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                          <span style={{ color: '#495057' }}>
                            {startDate ? moment(startDate).format('MMM D, YYYY') : 'Select start date'}
                          </span>
                        </div>
                      </Button>
                      {activeCalendar === 'start' && (
                        <div style={{ 
                          position: 'absolute', 
                          zIndex: 1000,
                          marginTop: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '6px',
                          boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                          border: '1px solid #eaedf3'
                        }}>
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                              handleDateChange('start', date);
                              setActiveCalendar('end');
                            }}
                            maxDate={endDate || new Date()}
                            inline
                            calendarClassName="single-date-calendar"
                          />
                        </div>
                      )}
                    </div>
                    <div className="flex-grow-1">
                      <Button 
                        block
                        theme="white"
                        style={{
                          borderColor: '#e1e5eb',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          position: 'relative',
                          height: '38px'
                        }}
                        onClick={() => setActiveCalendar(activeCalendar === 'end' ? null : 'end')}
                      >
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faCalendar} className="mr-2" style={{ color: '#21AA73' }} />
                          <span style={{ color: '#495057' }}>
                            {endDate ? moment(endDate).format('MMM D, YYYY') : 'Select end date'}
                          </span>
                        </div>
                      </Button>
                      {activeCalendar === 'end' && (
                        <div style={{ 
                          position: 'absolute', 
                          zIndex: 1000,
                          marginTop: '8px',
                          backgroundColor: '#fff',
                          borderRadius: '6px',
                          boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                          border: '1px solid #eaedf3'
                        }}>
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => {
                              handleDateChange('end', date);
                              setActiveCalendar(null);
                            }}
                            minDate={startDate}
                            maxDate={new Date()}
                            inline
                            calendarClassName="single-date-calendar"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <style>
                    {`
                      .single-date-calendar .react-datepicker__day--selected {
                        background-color: #21AA73 !important;
                        border-radius: 50% !important;
                      }
                      .single-date-calendar .react-datepicker__day--in-range,
                      .single-date-calendar .react-datepicker__day--in-selecting-range {
                        background-color: transparent !important;
                        color: inherit !important;
                      }
                      .single-date-calendar .react-datepicker__day:hover {
                        background-color: rgba(33, 170, 115, 0.1) !important;
                        border-radius: 50% !important;
                      }
                    `}
                  </style>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card>
                <CardHeader className="border-bottom">
                  <h6 className="m-0">Quick Select</h6>
                </CardHeader>
                <CardBody className="p-3">
                  <div className="d-flex flex-column" style={{ gap: '8px' }}>
                    <Button 
                      theme="light" 
                      size="sm" 
                      block
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('today')}
                    >
                      Today
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('yesterday')}
                    >
                      Yesterday
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('lastWeek')}
                    >
                      Last 7 days
                    </Button>
                    <Button 
                      theme="light" 
                      size="sm"
                      block 
                      style={{
                        fontSize: '13px',
                        color: '#21AA73',
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        textAlign: 'left',
                        padding: '10px 12px'
                      }} 
                      onClick={() => handlePresetClick('lastMonth')}
                    >
                      Last 30 days
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button theme="light" onClick={() => setShowDatePickerModal(false)}>Cancel</Button>
          <Button theme="primary" onClick={() => setShowDatePickerModal(false)}>Apply</Button>
        </ModalFooter>
      </Modal>

      {/* AI Analysis Modal */}
      <Modal open={showAnalysisModal} toggle={() => setShowAnalysisModal(!showAnalysisModal)} size="lg">
        <ModalHeader toggle={() => setShowAnalysisModal(!showAnalysisModal)}>
          <FontAwesomeIcon icon={faBrain} className="mr-2" style={{ color: "#6772e5" }} />
          AI Dispute Analysis - Citation #{selectedForAnalysis?.violation_number}
        </ModalHeader>
        <ModalBody>
          {selectedForAnalysis && selectedForAnalysis.dispute && (
            <DisputeAnalysisContainer
              citation={selectedForAnalysis}
              dispute={selectedForAnalysis.dispute}
              locationRules={selectedForAnalysis?.location ? props.locations.find(loc => loc.id === selectedForAnalysis.location)?.rules : ''}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button theme="light" onClick={() => setShowAnalysisModal(!showAnalysisModal)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Dispute Quick View Modal */}
      <DisputeQuickView
        isOpen={showDisputeModal}
        toggle={() => setShowDisputeModal(!showDisputeModal)}
        citation={selectedDispute}
        onAccept={handleAcceptDispute}
        onReject={handleRejectDispute}
        onAdjust={handleAdjustDispute}
        onViewFull={handleViewFullCitation}
        users={props.users}
        isSuperAdmin={props.user?.type === 'super'}
      />

      {/* Payment Method Selection Modal */}
      <Modal 
        open={showPaymentMethodModal} 
        toggle={() => setShowPaymentMethodModal(!showPaymentMethodModal)}
        size="sm"
      >
        <ModalHeader toggle={() => setShowPaymentMethodModal(!showPaymentMethodModal)}>
          <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{ color: '#21AA73' }} />
          Select Payment Method
        </ModalHeader>
        <ModalBody className="p-4">
          <p className="text-muted mb-3">
            Citation #{selectedCitationForPayment?.violation_number}
          </p>
          <p className="mb-4">
            How was this citation paid?
          </p>
                      <div className="d-flex flex-column" style={{ gap: '12px' }}>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Check')}
              >
                Check
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Cash')}
              >
                Cash
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('ACH')}
              >
                ACH
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Money Order')}
              >
                Money Order
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Offline Credit')}
              >
                Offline Credit
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Other')}
              >
                Other
              </Button>
            </div>
        </ModalBody>
        <ModalFooter>
          <Button 
            theme="light" 
            onClick={() => {
              setShowPaymentMethodModal(false);
              setSelectedCitationForPayment(null);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default Citations;
